<template>
  <div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vx-card>
          <h4 style="font-family: Lora; font-size: x-large">
            Global COVID-19 Data Dashboard:
          </h4>
          <Breadcrumbs
            :breadcrumbs="[
              { title: 'Dashboards', to: `/dashboard` },
              { title: 'Global Dashboard', to: '/dashboards/global' }
            ]"
          />

          <p class="mt-2">
            Data sourced from Johns Hopkins global cases tracking centre. Data
            updated every 15 minutes.
          </p>
          <p>
            For more information on how this data is collected and maintained,
            please see the
            <a href="https://coronavirus.jhu.edu/" target="_blank"
              >Johns Hopkins Coronavirus Resource Centre</a
            >
          </p>
        </vx-card>
      </div>
    </div>
    <div class="flex flex-row">
      <iframe
        class="hopkinsIframe"
        scrolling="no"
        title="Coronavirus COVID-19 Global Cases by Johns Hopkins CSSE"
        :src="hopkinsUrl"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import ActiveCasesCard from "@/modules/dashboard/components/dashboard-cards/ActiveCasesCard";
import NewCasesCard from "@/modules/dashboard/components/dashboard-cards/NewCasesCard";
import TotalCasesCard from "@/modules/dashboard/components/dashboard-cards/TotalCasesCard";
import CriticalCasesCard from "@/modules/dashboard/components/dashboard-cards/CriticalCasesCard";
import RecoveredCasesCard from "@/modules/dashboard/components/dashboard-cards/RecoveredCasesCard";
import NewDeathsCard from "@/modules/dashboard/components/dashboard-cards/NewDeathsCard";
import TotalDeathsCard from "@/modules/dashboard/components/dashboard-cards/TotalDeathsCard";
import Breadcrumbs from "@/components/general-components/breadcrumbs/Breadcrumbs";
import GraphTile from "@/modules/dashboard/components/dashboard-cards/GraphTile";

export default {
  name: "GlobalDashboard",
  components: {
    ActiveCasesCard,
    NewCasesCard,
    TotalCasesCard,
    CriticalCasesCard,
    RecoveredCasesCard,
    NewDeathsCard,
    TotalDeathsCard,
    Breadcrumbs,
    GraphTile
  },
  data() {
    return {
      desktopUrl:
        "https://www.arcgis.com/apps/opsdashboard/index.html#/bda7594740fd40299423467b48e9ecf6",
      mobileUrl:
        "https://www.arcgis.com/apps/opsdashboard/index.html#/85320e2ea5424dfaaa75ae62e5c06e61",
      dateRange: [],
      dataSets: {},
      loading: true
    };
  },
  computed: {
    hopkinsUrl() {
      return window.innerWidth > 1200 ? this.desktopUrl : this.mobileUrl;
    }
  }
};
</script>

<style scoped>
.breadcrumb ::v-deep .vs-breadcrumb--ol {
  padding-left: 0px !important;
  padding-top: 0px !important;
}
.hopkinsIframe {
  height: 100vh;
  width: 100vw;
  margin: 0;
}
</style>
